(() => {
  'use strict';

  const delayMessage = " If we expect any delay beyond this, we'll do our best to let you know as soon as possible.";

  function addDelayMessage() {
    document.querySelectorAll('.mf-accordions details').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary || summary.textContent.trim() !== 'Shipping & returns') return;

      const firstParagraph = details.querySelector('div p');
      if (!firstParagraph || firstParagraph.dataset.mfDelayMessageAdded === 'true') return;

      if (!firstParagraph.textContent.includes("we'll do our best to let you know")) {
        firstParagraph.append(document.createTextNode(delayMessage));
      }
      firstParagraph.dataset.mfDelayMessageAdded = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addDelayMessage, { once: true });
  } else {
    addDelayMessage();
  }

  [250, 750, 1500].forEach((delay) => window.setTimeout(addDelayMessage, delay));
  document.addEventListener('shopify:section:load', addDelayMessage);
})();